exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex-container {\n  display: flex;\n  flex-direction: row;\n}\nphone-mock,\n.phone-mock {\n  width: 265px;\n  position: relative;\n}\nphone-mock iframe,\n.phone-mock iframe {\n  width: 410px;\n  height: 735px;\n  position: absolute;\n  transform: scale(0.5);\n  top: -67px;\n  left: -73px;\n}\nphone-mock .btn-reload,\n.phone-mock .btn-reload {\n  position: absolute;\n  top: 96px;\n  right: 31px;\n}\n.style-settings {\n  flex-grow: 1;\n  margin-left: 20px;\n}\n.style-settings .tab-pane {\n  padding-left: 15px;\n  padding-right: 15px;\n  padding-bottom: 15px;\n}\n", ""]);

// exports
